export default {
  general: {
    labels: {
      status: 'Status',
      actions: 'Actions',
      copied: 'Copied',
      error: 'Error',
      standard: 'Default',
      step: 'Step',
      steps: 'Steps',
      times: 'times(s)',
      table: 'Table ',
      exporting: 'Exporting',
      your: 'Your',
      in: 'in',
      date: 'DATE',
      box_name: 'Research Form Name',
      new_box: 'New Research Form',
      next: 'NEXT',
      edition: 'Edit',
      editing: 'Editing',
      description: 'Description',
      title: 'Title',
      days: 'Days',
      configurations: 'Settings',
      and: 'and',
      seconds: 'Seconds',
      homepage: 'Homepage',
      hotmart_logo: 'Hotmart logo',
      themes: 'Models',
      saving: 'Saving',
      jump: 'Jump',
      destinations: 'Destinations',
      first: 'First',
      last: 'Last',
      to: 'TO',
      button: 'Button',
      external: 'External',
      center: 'Center',
      left: 'Left',
      right: 'Right',
      other: 'Other',
      option: 'Option',
    },
    actions: {
      new: 'CREATE FORM',
      delete: 'Delete',
      export: 'Export',
      report: 'Report',
      edit: 'Edit',
      copy: 'Copy',
      close: 'Close',
      cancel: 'Cancel',
      duplicate: 'Duplicate',
      publish: 'Post',
      back: 'Back',
      click: 'CLICK',
      add: 'ADD',
    },
  },
  index: {
    title: 'Research Forms',
    subtitle: 'The simplest, easiest way to create your Researches',
    find_a_box: 'Search for a Research Form',
    list_header: {
      modality: 'Modality',
      last_modification: 'Last change',
    },
  },
  error: {
    oops: 'oops',
    page_not_exists: 'This page may not exist...',
    check_url: 'Make sure the address is spelled correctly or try again later',
    something_wrong: 'Something seems wrong...',
    system_offline: 'The system may be down.',
    our_devs: 'But our team is already working to get this problem solved.',
    try_again_later: 'Try again in a few minutes',
  },
  modal: {
    cant_export_table: {
      title: 'This report cannot be exported',
      max_limit: 'The maximum limit to export results is',
      select_interval: ' answers. Please select a shorter period of time.',
    },
    code: {
      step_one: 'Copy the Research Form code below and paste it on your page',
      step_two: 'Copy the button code below',
      step_three: 'and add it to the link or button that opens the Research Form',
    },
    delete_box: {
      are_you_sure: 'Do you really wish to delete this Research Form?',
      yes: 'Yes, I want to delete this Research Form!',
    },
    delete_step: {
      are_you_sure: 'Do you really wish to delete this step?',
      yes: 'Yes, I want to delete this step!',
    },
    duplicate_step: {
      are_you_sure: 'Do you really wish to duplicate this step?',
      yes: 'Yes, I want to duplicate this step!',
    },
    export_table: {
      answer_table: 'Answer table',
      insert: 'Enter your email below so we can send you the answer table as soon as it is ready',
    },
    export_table_in_progress: {
      processing_request: 'request is being processed',
      send_email: 'and as soon as it is complete we will send it to the email',
      some_hours: 'This process could take a few hours',
    },
  },
  report: {
    menu: {
      report_of: 'Report for',
      back_to_answers_summary: 'Back to answer summary',
      metrics: 'Metrics',
      individual_answers: 'Individual answers',
      box_options: 'Research Form options',
    },
    charts: {
      total_answers: 'Total answers',
    },
    individual: {
      date_filter: 'FILTER BY PERIOD OF TIME',
      date_range: 'PERIOD OF TIME',
      from: 'From',
      to: 'to',
      answered_in: 'Answered in',
      obtained_answers: 'answers received',
    },
    metrics: {
      total_visits: 'TOTAL VISITS',
      visits_without_answers: 'VISITS WITH NO ANSWERS',
      quizzes_not_completed: 'QUIZZES NOT COMPLETED',
      quizzes_completed: 'QUIZZES COMPLETED',
      completion_rate: 'COMPLETION RATE',
      average_time_to_complete: 'AVERAGE TIME TO COMPLETE',
      desktop: 'PCs & LAPTOPS',
      tablet: 'tablet',
      mobile: 'mobile',
      others: 'other',
    },
    emails: {
      captured_emails: 'captured emails',
      who_answered: 'those who replied',
    },
    resume: {
      question_not_answered: 'This question does not yet have an answer',
      no_information_found: 'No information found',
    },
  },
  edit: {
    canvas: {
      visualizing: 'Viewing',
      active_item: 'Active Item',
      default_item: 'Standard Item',
      past_item: 'Past Item',
      progressbar: 'Progress Bar',
      general_styles: 'General Styles',
      answer_options: 'Response Options',
      redirect_button: 'Redirect Butoon',
      positive_button: 'Positive Button',
      positive_button_text: 'Positive Button Text',
      negative_button: 'Negative Button',
      negative_button_text: 'Text for the Negative Button',
      welcome_title: 'Welcome Title',
      welcome_description: 'Welcome Description',
      welcome_buttons: 'Welcome Buttons',
      welcome_active: 'Activate Welcome Step',
      next_button: 'Next Button',
      question_description: 'Question Description',
      question_description_placeholder: 'Call Description',
      question_title: 'Question Title',
      question_title_placeholder: 'Type your question here',
      all_steps: 'All of the Steps',
      mail_service: 'Email service',
      mail_service_text_area: 'Put the HTML code here for the form provided by your email service',
      custom_html_form: 'Customized HTML Form',
      redirect_by_mail_service: 'Redirection by email service',
      multiple_answers: 'Allow more than one answer',
      add_other_option: 'Add option "other"',
      redirect_url: 'Redirecting URL',
      auto_redirect: 'Automatic Redirection',
      required_response: 'Answer Required',
      multiline_response: 'Multi-line response',
      multiple_choice_placeholder: 'Enter one response option',
      add_option: 'Add Option ',
      button_text: 'Button Text',
      start_button_text: 'Start Button Text',
      next_button_text: 'Next Button Text',
      you_are_editing: 'You are editing the',
      external_button: 'EXTERNAL BUTTON',
      click_button: 'Click the button',
      copy_the: 'Copy the',
      box_code: 'Research Form code',
      call_button_code: 'cta button code',
      past_in_your_page: 'and paste it to your page',
      add_to_link_or_button: 'and add it to the link or button that opens the Research Form',
      see_flow: 'View Flow',
      first_value_welcome_select: 'Yes or No',
      second_value_welcome_select: 'Start',
    },
    sidebar: {
      interval_until_action: 'Show in a set time interval until the visitor takes the action',
      times_until_action: 'Display limited times until the visitor takes the action',
      until_action: 'Display until the visitor carries out the action',
      display_frequency: 'Display Frequency',
      when_box_should_display: 'When should the Research Form appear?',
      exibition_mode: 'View mode',
      how_box_should_display: 'At what point should the Research Form appear to your visitor?',
      when_leave_the_page: 'When leaving the page',
      immediately_when_access: 'Immediately when accessing',
      on_scroll: 'When scrolling',
      until_page_top: 'At the top of the page (25%)',
      until_page_middle: 'Up to half the page (50%)',
      until_page_bottom: 'Up to the end of the page (75%)',
      by_time_on_page: 'By time on page',
      call_button_style: 'CTA Button Style',
      background_color: 'Background color',
      border_color: 'Border color',
      border_radius: 'Rounding',
      text_color: 'Text color',
      visibility: 'Visibility',
      font: 'Font',
      font_size: 'Text size',
      height: 'Height',
      width: 'Width',
      add_jump: 'Add Jump',
      add_answer: 'Add answer',
      select_destiny: 'Select a destination',
      all_other_cases: 'In all other cases go to...',
      always_jump_to: 'Always Jump to...',
      select_one_answer: 'Select an answer',
      select_the_answers: 'Select answers',
      choose_one_answer: 'Choose an answer',
      go_to_next: 'Go to the next',
      add_one_question: 'add ONE question by CLICKING ON THIS BUTTON',
      question: 'question',
      yes_no: 'yes/no',
      text: 'text',
      capture: 'Email',
      of_email: 'capture',
      redirec: 'REDI',
      tion: 'RECT',
      format: 'Format',
      choose_a_theme: 'PICK A TEMPLATE',
      edit_theme: 'Edit theme ',
      without_style: 'No Style',
      alignment: 'Alignment',
      call_button: 'CTA Button',
      in_one_component: 'In one component',
      one_component_to_integrate: 'A component to integrate into your page',
      in_full_screen: 'In full screen',
      one_screen_that_cover: 'A screen covers your page completely',
      in_mini_slider: 'On a mini slide',
      one_small_window_apper: 'A little window appearing on the lower corner of the page',
      in_a_popup: 'In a pop-up',
      one_box_apper_in_the_middle: 'A Research Form appearing in the middle of the screen',
      in_a_slider: 'In a slide',
      one_screen_apper_right: 'A screen appearing on the right',
      how_might_show: 'How do you want to display it?',
      select_box_format: 'Select the format of your Research Form',
      auto: 'Automatically',
      at_some_point: 'Sometime during access',
      on_click: 'When clicking',
      on_click_some_button: 'When clicking on a button within the page',
      when_might_show: 'When do you want to display it?',
      select_when_box_should_apper: 'Select when the Research Form should appear',
      configure_box: 'Set up Research Form',
    },
  },
  step_kinds: {
    kinds: {
      multiple_choise: {
        title: 'What is your question?',
        description_text: 'Question description',
      },
      yes_no: {
        title: 'What is your question?',
        description_text: 'Question description',
      },
      text: {
        title: 'What is your name?',
        description_text: '',
        placeholder: 'Enter your name here...',
      },
      email: {
        title: 'What is your email address?',
        description_text: '',
      },
      redirect: {
        title: 'Congratulations! Click here to access your personalized content',
        description_text: '',
        button_text: 'Access page',
      },
      thanks: {
        title: 'Thank you!',
        description_text: 'Your information has been successfully stored in our survey!',
      },
    },
    options: {
      multiple_choise: {
        first_option: 'Option 1',
        second_option: 'Option 2',
      },
      yes_no: {
        yes: 'Yes',
        no: 'No',
      },
    },
  },
  notifications: {
    noNotifications: 'There are no new notifications.',
    unableLoad: 'We were unable to load notifications at this time.',
  },
  empty: {
    title: 'Create forms to get to know your customers better and capture contacts',
    subtitle: `You can conduct surveys that will help you understand your audience.
               At the end of the form, gather the leads (contacts) of the people who will respond.`,
    link: 'Learn about form formats you can create',
    button: 'Create form',
    url: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
    urlExtensions: 'https://suporteklickpages.zendesk.com/hc/pt-br/articles/4587915332109-Conhecendo-o-Klickbox',
  },
};



/** WEBPACK FOOTER **
 ** ./src/i18n/messages/languages/en.js
 **/